module.exports = __webpack_public_path__ + "images/80c9586b7aa629f1ec2bdbbcbbf44805.png";